import { ChiliMildIcon } from './ChiliMildIcon';

/**
 * author: Andy Martinez
 * id 3CE5B420-F103-47EA-800C-A4D145B89508
 * name chili-mild
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chili-mild.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const ChilliMildIcon = ChiliMildIcon;
export default ChilliMildIcon